// visitedViews / cachedViews / userInfo / hasBtnPermission 等 getter 已在 appStore 模块内定义
const getters = {}

export default getters
